module.exports = __webpack_public_path__ + "img/page51.84808991.gif";